export const LandscapeDesign = [
  {
    id: 1,
    title: 'Ландшафтний дизайн: важливий елемент чи примха?',
    description:
      `
     Будинки в іспанському стилі, особливо в середземноморському кліматі Каталонії, нерозривно пов'язані зі створенням унікальних садів. Тут сформувалися певні особливості місцевого ландшафтного мистецтва, які досі впливають на дизайн садів у цій місцевості. Однією з характерних рис є використання живих квітів для прикрашання фасаду будинку. Часто використовуються горшкові або в'юнкі рослини, які надають будинку особливого шарму і краси. Важливим елементом є створення куточка для приємного проведення часу з друзями та родичами. Це може бути декороване місце для застілля або відпочинку, де можна насолодитися атмосферою і спілкуванням. Популярним традиційним елементом є патіо - затишний внутрішній дворик з тінистими місцями для сидіння і зручними меблями. Це місце, де можна насолодитися свіжим повітрям і усамітненням у власному саду. В каталонських садах вітається велика кількість і різноманітність рослин всіх видів, від мохів до витких рослин. Тут можна побачити рослини в горщиках і контейнерах, які додають яскраві акценти і створюють цікаві композиції. Ландшафтний дизайн є невід'ємною частиною ринку нерухомості в Іспанії. Екстер'єр допомагає підвищити вартість нерухомості та продемонструвати індивідуальність власника будинку.

     `,
  },
  {
    id: 2,
    title: 'Скільки часу зазвичай займає розробка та реалізація ландшафтного проекту?',
    description:
      `
      Розробка та реалізація ландшафтного проекту - це творчий і багатогранний процес, який вимагає часу і уваги до деталей. Терміни виконання проекту можуть варіюватися в залежності від обсягу, складності та конкретних вимог клієнта. Невеликі ландшафтні проекти, такі як невеликий сад або тераса, можуть бути розроблені і реалізовані за кілька тижнів або місяців. У цих випадках процес включає в себе
Складання дизайн-плану.
Вибір рослин і матеріалів.
Виконання робіт з озеленення та декорування. Середні проекти, такі як озеленення заміської ділянки або території громади, можуть потребувати кілька місяців роботи. У цьому випадку процес включає більш детальне планування, консультації з клієнтом, розробку концепції та 3D-візуалізацію, а також реалізацію озеленення, архітектурних елементів та інфраструктури. Більші та складніші проекти, такі як озеленення громадських парків чи комплексів, можуть потребувати років роботи. У таких випадках процес включає в себе
Довгострокове планування.
Розробка генерального плану.
Участь у погодженнях з державними органами та іншими зацікавленими сторонами.
Поетапна реалізація проекту. Наші фахівці постараються зробити для вас ідеальний інтер'єр в найкоротші терміни. Тому не відкладайте на завтра, замовте послугу вже сьогодні і дізнайтеся деталі термінів виконання робіт.

      `,
  },
  {
    id: 3,
    title: 'Ландшафтний дизайн: зробити своїми руками чи скористатися послугами професіоналів?',
    description:
      `
      Картинка у вашій голові іноді збігається з реальністю. Ландшафтний дизайн - це мистецтво створення красивих і функціональних просторів, які приносять радість і комфорт. Втілюючи свою мрію про ідеальний сад або ділянку, виникає питання: робити все самостійно або звернутися за допомогою до професіоналів? Власний ландшафтний дизайн може бути захоплюючим і творчим процесом, який дозволяє втілити в життя власні ідеї та вподобання. Роблячи все самостійно, ви можете заощадити певні кошти і мати повний контроль над процесом реалізації. Це може бути особливо цікаво для людей з певними навичками та знаннями в галузі ландшафтного дизайну та озеленення. Але ландшафтний дизайн - це складний і багатогранний процес, який вимагає глибоких знань про рослини, ґрунти, кліматичні умови, а також досвіду планування і композиції. Неправильне планування або підбір рослин може призвести до незадовільних результатів і втрати часу та грошей. Наші фахівці мають необхідні знання та досвід, щоб створити унікальний і функціональний дизайн, враховуючи ваші побажання та особливості ділянки. Вони зможуть примножити переваги та приховати недоліки території, максимально грамотно використати кожен квадратний метр і зосередитися на комфорті мешканців. А також заощадять ваш час і сили, ефективно використовуючи ресурси.

      `,
  },
  {
    id: 4,
    title: `Доглядати за екстер'єром самостійно чи скористатися послугами спеціалістів?
`,
    description:
      `
      Після завершення проекту наші ландшафтні дизайнери можуть запропонувати свою допомогу та поради щодо догляду, щоб допомогти вам зберегти красу та здоров'я вашого ландшафту на довгі роки. Вони порадять вам, як правильно поливати, удобрювати, обрізати та доглядати за рослинами. Адже кожна рослина вимагає свого унікального підходу, і професіонали допоможуть вам визначити оптимальний режим догляду. Крім того, ландшафтні дизайнери можуть проконсультувати щодо утримання та догляду за іншими елементами вашого саду або екстер'єру, такими як доріжки, фонтани та штучні водойми. Вони поділяться з вами своїми знаннями щодо правильного очищення та догляду за цими об'єктами, щоб вони завжди виглядали привабливо та безпечно. Крім того, ландшафтні дизайнери допоможуть вам визначити сезонні роботи та догляд, яких потребує ваш сад. Вони підкажуть, як підготувати сад до зими або літа, як правильно прибирати листя, обрізати рослини або провести необхідні роботи з догляду. Якщо ви хочете заощадити час, ви можете продовжити співпрацю з нами, і ми допоможемо вам доглядати за вашим садом.

      `,
  },
  {
    id: 5,
    title: 'Рулонні газони або посівні, що краще для ділянки?',
    description:
      `
      Ось кілька запитань, які можуть допомогти вам прийняти рішення:
Який розмір ділянки? Рулонним газонам зазвичай віддають перевагу на невеликих і середніх ділянках, оскільки їх можна швидко укласти і відразу надати саду завершеного вигляду. Насіннєві газони найкраще підходять для великих ділянок, де може бути виправданий більш тривалий процес посіву.
Скільки часу ви готові витратити на створення газону? Посів газону потребує більше часу. Рулонні газони дають швидкі результати, готові до використання після укладання.
Який ваш бюджет? Насіннєвий газон може бути більш економічним, особливо на великих площах. Рулонні газони зазвичай дорожчі, ніж насіннєві, але вони дають більш швидкий результат.
Який клімат у вашому регіоні? Деякі види газону можуть бути більш пристосовані до певних кліматичних умов, наприклад, до сухих або вологих регіонів. Насіннєві газони можуть бути більш гнучкими у виборі сортів трав, які краще пристосовані до вашого клімату.
Якого естетичного ефекту ви хочете досягти? Рулонні газони зазвичай мають більш однорідний і миттєвий вигляд, тоді як сіяні газони можуть створити більш природний і прогресивний ландшафт.

      
      `,
  },
  {
    id: 6,
    title: 'Що вибрати, автоматичний полив або ручний полив рослин?',
    description:
      `
      Автоматичний полив:
Автоматичний полив забезпечує зручність, особливо якщо у вас великий сад або багато рослин. Ви можете задати програму поливу, і система буде самостійно стежити за регулярним і рівномірним поливом рослин без вашої присутності.
Автоматичний полив економить час, який би ви витрачали на полив кожної рослини вручну.
Системи автоматичного поливу часто оснащені датчиками вологості, які визначають, коли рослинам потрібен полив, і подають воду лише тоді, коли це необхідно. Це допомагає уникнути марної витрати води та заощадити її. Ручний полив:
Ручний полив дозволяє контролювати процес поливу і безпосередньо взаємодіяти з рослинами. Ви можете краще спостерігати за їх станом і реагувати на будь-які проблеми чи потреби.
Ручний полив дозволяє вибирати місця і кількість поливу для кожної рослини окремо. Ви можете адаптувати полив до особливостей кожної рослини, її потреб у волозі та умов навколишнього середовища.
Ручний полив не вимагає встановлення спеціального обладнання та системи, що може бути більш економічно вигідним, ніж автоматичний полив. Обираючи між автоматичним і ручним поливом рослин, враховуйте розмір вашого саду, кількість рослин, доступність води і переваги у догляді за рослинами. За додатковими консультаціями та детальним аналізом ви можете звернутися до наших фахівців.

      
      `,
  },

  
];

export const Interior = [
  {
    id: 1,
    title: `Чому б не обійтися без наших інтер'єрних послуг?`,
    description: `
      Дизайн-проект інтер'єру - це ключовий інструмент, який допомагає створити гармонійний і функціональний простір, що відповідає вашому стилю життя. Ось кілька причин, чому дизайн-проект є невід'ємною частиною успішного оновлення та організації інтер'єру.
Дизайн-проект допомагає максимально ефективно використати наявний простір. Він пропонує розумне розміщення меблів, аксесуарів та функціональних зон для створення комфортного та практичного простору, що відповідає вашим потребам.
Важливо, щоб інтер'єр відображав ваш стиль життя і відповідав вашим потребам. Дизайнери враховують ваші вподобання, хобі та розпорядок дня, щоб створити функціональний і приємний інтер'єр для вас і вашої родини.
Дизайн-проект дозволяє заздалегідь оцінити всі елементи інтер'єру та уявити, як вони будуть виглядати в реальності. За допомогою візуалізацій і планів можна переглянути різні варіанти кольорів, матеріалів, меблів і декору та прийняти зважене рішення.
Складання дизайн-проекту дозволяє визначити вартість робіт і точніше спланувати бюджет ремонту. Ви зможете заздалегідь побачити всі витрати, пов'язані з матеріалами, меблями, оздобленням, послугами дизайнера, і контролювати витрати під час реалізації проекту.
Дизайн-проект допомагає уникнути помилок під час ремонту і дозволяє професіоналам врахувати всі технічні аспекти та деталі. Це мінімізує можливість виникнення непередбачуваних проблем і невдалих рішень, а також скорочує час і витрати на виправлення помилок. А співпраця з Moderna Casa зробить всі процеси більш комфортними та приємними.

      `,
  },
  {
    id: 2,
    title: `Чи дорогий дизайн інтер'єру?
`,
    description: `Звичайно, при розробці дизайн-проекту ми враховуємо ваш бюджет. Ми розуміємо, що кожен клієнт має свої фінансові можливості та обмеження, тому наша мета - створити інтер'єр, який відображає ваш смак і стиль життя та відповідає вашим фінансовим можливостям. Ми прагнемо збалансувати стиль, функціональність і доступність, щоб створити інтер'єр, який буде не тільки естетично приємним, але й економічно вигідним. Наша команда має досвід роботи з різними бюджетами, тому ми готові запропонувати варіанти, що відповідають будь-яким фінансовим очікуванням. Під час роботи над інтер'єром та візуалізацією ми також можемо надати вам інформацію про приблизну вартість необхідних матеріалів, меблів та робіт, щоб ви мали уявлення про можливі витрати.

      `,
  },

  {
    id: 3,
    title: `Що таке послуга контролю на етапі проектування?

`,
    description: `
      Авторський нагляд - важливий етап реалізації дизайн-проекту, який гарантує відповідність ремонтно-будівельних робіт затвердженому проекту. В рамках авторського нагляду дизайнер і архітектор активно контролюють виконання всіх робіт і стежать за тим, щоб кожен крок відповідав ідеї проекту. Це включає в себе Постійний моніторинг процесу будівництва. Перевірка якості використовуваних матеріалів. Точність реалізації архітектурних рішень. Фахівці Moderna Casa також надають своєчасні відповіді на будь-які питання або проблеми, що виникають, і консультують замовника з питань, пов'язаних з дизайном і архітектурою.
      `,
  },

  {
    id: 4,
    title: `Які 3 основні складові процесу дизайну інтер'єру?


`,
    description: `
    Дизайн-проект включає в себе кілька важливих компонентів, які допомагають створити повну і детальну концепцію.
Одним з ключових елементів є 3D візуалізація, яка дозволяє уявити кожну деталь вашого простору. Завдяки цій техніці ми можемо підібрати найкращі матеріали та кольори, а також оцінити функціональність розміщення меблів та інших предметів з урахуванням ваших побажань.
Технічна документація включає багато планів і схем для правильної реалізації проекту. Вона складається з плану обмірів, плану розміщення меблів та обладнання, плану монтажу і демонтажу, плану підлоги із зазначенням типу підлогового покриття, плану стелі, плану розташування розеток і вимикачів, плану прив'язки світильників зі схемою вмикання, програми оздоблення стін, способу підключення сантехнічного обладнання, розгорток стін у ванних кімнатах і на кухні із зазначенням розкладки плитки, а також планів підлогового опалення і радіаторів. При виконанні цього пункту ми також враховуємо чинну законодавчу базу Іспанії.
Важливим аспектом дизайн-проекту є вибір матеріалів. Вся продукція, представлена на нашому сайті, може похвалитися високою якістю і довговічністю. Ми надаємо рекомендації та вказуємо конкретні оздоблювальні матеріали, меблі, сантехніку та освітлювальні прилади. Крім того, ми запрошуємо вас скористатися нашим інтернет-магазином, де ви можете придбати ці предмети і матеріали. Всі ці елементи дизайн-проекту працюють разом для створення повної і детальної концепції інтер'єру, від 3D-візуалізації до технічної документації та підбору матеріалів, щоб реалізувати ваші побажання і створити ідеальний простір, який відображає ваш стиль і вподобання.

      `,
  },

  {
    id: 5,
    title: `Інтер'єр в іспанському стилі: як він виглядає?



`,
    description: `
   Меблі простого дизайну з чорного або червоного дерева, шкіряні крісла та стільці. Іспанський стиль в інтер'єрі відрізняється світлими і теплими тонами, використанням натуральних матеріалів та елементів з каменю, дерева, кераміки. Затишок створюють декоративні подушки та свічки. Особливістю інтер'єру є старовинні меблі, антикваріат, сімейні фотографії та настінні картини. Шпалер і килимів немає, натомість використовуються пофарбовані стіни, плитка і дерев'яна підлога. Популярні дерев'яні балки на стелі та шафи в нішах. Є великий обідній стіл для сімейних вечерь. У декорі - картини в дерев'яних рамах, керамічний посуд, статуетки, вази, свічки. Використана керамічна плитка з ручним розписом. Ви можете проконсультуватися з нами, і ми розповімо вам більше про особливості інтер'єру країн Середземномор'я. Ми також створюємо дизайн-проекти в інших стилях і прислухаємося до ваших порад та побажань.

      `,
  },
  {
    id: 6,
    title: `Скільки часу займає процес розробки концепції інтер'єру?




`,
    description: `
  Розробка дизайн-проекту приватного будинку в Іспанії займає близько 25-45 днів і виконується паралельно з будівництвом. Дизайнер-проектувальник виконує не тільки розробку концепції інтер'єру, а й вирішує інженерно-технічні питання. За цей час фахівець виконує наступні завдання:
Підготовка габаритних креслень і схем інженерних систем.
Створення візуалізації інтер'єру на комп'ютері та створення колажів.
Розробка дизайн-схем для стелі, стін та підлоги.
Планування розташування дверей, розеток і світильників.
Організація підлогового опалення та кондиціонування.
Пошук і закупівля матеріалів, зазначених у дизайн-проекті будинку.
Оформлення технічної та юридичної документації.
Координація будівництва, контроль термінів та якості робіт.

      `,
  },
];

export const Architect = [
  {
    id: 1,
    title: 'Скільки часу займає архітектурний проект?',
    description:
      "Оптимальні терміни проектування індивідуального житлового будинку залежать від взаємодії між архітектором і замовником. Чим ефективніший зворотній зв'язок і схвалення запропонованих проектних рішень, тим швидше буде завершено проектування. Зазвичай процес займає від 1 місяця до 3 місяців, але у випадку зі складними об'єктами розробка повного проекту може зайняти до півроку.",
  },
  {
    id: 2,
    title: 'Дизайн-проект і робочий проект - в чому їх особливості?',
    description: `
      Дизайн-проект і робочий проект відрізняються за своїми характеристиками та функціональністю. Дизайн-проект - це абстрактні дані, які дають уявлення про зовнішній вигляд і концепцію майбутнього будинку. У той же час, робочий проект - це детальні та розроблені креслення і документація, необхідні для фактичного будівництва. Ці документи служать безпосереднім керівництвом і основою для всіх будівельних робіт.

      `,
  },
  {
    id: 3,
    title: 'Який проект дешевший: типовий чи індивідуальний?',
    description: `
     Оригінальні та типові проекти мають різну вартість. Типовий проект, як правило, більш доступний за ціною, оскільки він вже розроблений і перепродається після покриття початкових витрат. Однак типовий проект має суттєвий недолік, оскільки він створювався з урахуванням конкретної місцевості, інженерних комунікацій, орієнтації ділянки та кліматичних умов. Типове рішення може лише частково задовольнити ваші бажання і вимоги, тому внесення змін може призвести до додаткових витрат і затримки будівництва. Тому, звертаючись до наших фахівців, ви можете бути впевнені, що для вас буде розроблений індивідуальний проект з урахуванням рекомендацій.
      `,
  },

  {
    id: 4,
    title: 'З яких етапів складається проектування та будівництво будинку?',
    description: `
    Послідовність будівництва приватного будинку зазвичай така: Земляні роботи, якщо є дозвіл на будівництво та готовий проект будинку.
Будівництво фундаменту.
Будівництво стін і стель.
Виконання покрівельних робіт.
Встановлення вікон.
Прокладання внутрішніх комунікацій та прокладання зовнішніх інженерних мереж.
Внутрішні оздоблювальні роботи, включаючи стелі та підлоги.
Встановлення дверей та сходів.
Монтаж та підключення інженерного обладнання.
Проведення зовнішнього оздоблення. Така послідовність дозволяє будувати будинок поетапно, від фундаменту до екстер'єру, забезпечуючи системний і структурований підхід до будівництва.

      `,
  },

   {
    id: 5,
    title: 'Який архітектурний стиль найпоширеніший у нерухомості в Іспанії?',
    description: `
    Середземноморський стиль будинків популярний у південних провінціях Іспанії. Фасади зазвичай оздоблюють білою штукатуркою, використовують арочні вікна та двері, а також відкриті галереї та тераси. Дахи вкриті коричневою або помаранчевою черепицею. Цей стиль добре підходить для спекотного клімату півдня Іспанії, забезпечуючи захист від сонця і створюючи неймовірні відчуття. У міру наближення до півночі архітектура будинків починає змінюватися. Можна зустріти будинки в колоніальному стилі або з фасадом з натурального каменю. У колоніальному стилі стіни зазвичай оброблені грубою штукатуркою або сировиною, підлоги зроблені з дерева, а на вікнах встановлені дерев'яні жалюзі. Сучасні будинки в стилі хай-тек стають все більш популярними. Переважання скла і металу в дизайні характеризує прямолінійні форми і лінії. Такі будинки, особливо з видом на море, відрізняються простором, оглядовістю і великою кількістю світла.

      `,
  },

   {
    id: 6,
    title: 'Які фактори слід враховувати при плануванні внутрішнього простору будинку?',
    description: `Визначте основні цілі та потреби вашої оселі. Розташуйте кімнати так, щоб кожна зона була зручною для використання і існувала логічна послідовність пересування між ними.
Враховуйте природний потік руху в будинку. Створюйте зручні шляхи з однієї кімнати в іншу, уникаючи вузьких і перевантажених коридорів.
Максимально використовуйте природне світло - розташуйте вікна так, щоб максимізувати природне освітлення і створити приємну атмосферу в приміщенні.
Враховуйте потребу в приватності в різних частинах будинку. Розмістіть спальні та ванні кімнати у віддалених частинах будинку, а місця загального користування зробіть більш відкритими.
Співвідношення розмірів і пропорцій кімнат має важливе значення для створення гармонійного і приємного візуального враження. Враховуйте правильні пропорції при розміщенні меблів та аксесуарів.
Подумайте про створення багатофункціональних просторів, які можна використовувати для різних цілей. Наприклад, об'єднану вітальню-їдальню або кабінет, який також можна використовувати як гостьову спальню.
Забезпечте достатньо місця для зберігання. Встановіть тумби або вбудовані шафи, щоб ефективно використовувати простір і зберігати речі впорядкованими.
Враховуйте свій стиль та вподобання при виборі оздоблення, кольорової гами та декору. Створіть атмосферу, яка відображає вашу індивідуальність і створює приємне враження. Фахівці Moderna Casa можуть надати більш детальні консультації та рекомендації щодо розробки архітектурного проекту. Ми зробимо ваш будинок комфортним для кожного члена сім'ї.

      `,
  },
];

export const ModularHouses = [
  {
    id: 1,
    title: 'Скільки часу займає збірка модульного будинку?',
    description:
      `
      Швидке і зручне будівництво модульних будинків приваблює багатьох людей. Ці будинки збираються з великих частин стін і перекриттів, які доставляються на будівельний майданчик. Збірка займає від 2 тижнів до 1,5 місяців, після чого починається оздоблення та встановлення інженерного обладнання. Готові модулі, що містять півкімнати або кілька ізольованих кімнат, доставляються на спеціальних вантажних платформах і встановлюються на заздалегідь підготовлений фундамент. Експрес-монтаж займає від двох до десяти днів, після чого будинок готовий до заселення. Модульні будинки ідеально підходять для тих, хто хоче бути відкритим для кількох місць і вважає за краще переїжджати. Наприклад, якщо вам доводиться часто їздити у відрядження, ви можете переїжджати, не турбуючись про пошук нового житла. Ваш будинок завжди буде з вами, як мушля равлика. Збірка модульного будинку зазвичай починається з розміщення першого модуля на фундаменті та його закріплення. Потім опускається наступний модуль і прикріплюється до попереднього, і так далі. Після складання стики герметизують, а потім переходять до монтажу даху.

      `,
  },
  {
    id: 2,
    title: 'Яка міцність і довговічність модульних будинків?',
    description:
      `
      Довговічність модульних будинків залежить від різних факторів, таких як технологія, матеріали та контроль якості, що використовуються. Вибираючи нас, ви можете бути впевнені, що ми використовуємо тільки якісні матеріали і працюємо сумлінно. Основні конструкції будинку можуть прослужити понад 50 років, що є значним терміном. Термін служби утеплювача визначити трохи складніше, оскільки немає багаторічної практики використання сучасних теплоізоляційних матеріалів. Однак, за умови відсутності намокання, можна припустити, що утеплювач прослужить близько 20-25 років. Таку статистику можна відстежити на територіях Іспанії, де немає високої вологості та дощів. Важливо зазначити, що фізичний знос рідко призводить до того, що будинок стає непридатним для використання. Натомість такий будинок може стати морально застарілим, і власники можуть прийняти рішення про його продаж або перебудову відповідно до сучасних вимог та смаків. Тому ви можете звернутися до нас у будь-який час, щоб освіжити свої квадратні метри.

      `,
  },
  {
    id: 3,
    title: 'Наскільки популярні модульні будинки в Іспанії?',
    description:
      `
      Модульні будинки набули популярності в Європі в останні роки, і їхня привабливість пояснюється не лише зниженням вартості, але й можливістю запропонувати рішення для подолання економічної кризи, спричиненої пандемією Covid-19. Іспанія найактивніше використовує модульні будинки серед усіх європейських країн. Однак історія модульних будинків сягає корінням у післявоєнну епоху. Саме тоді з'явився цей тип житла, який будувався швидко і недорого, щоб задовольнити величезний попит на житлову площу. Термін "модульний" означає, що будинок будується з окремих модулів. Кожен модуль створюється незалежно. Більша частина роботи виконується на заводі, де окремі модулі виготовляються з різних матеріалів. Потім ці модулі доставляються на земельну ділянку покупця і нарешті збираються разом, щоб створити будинок на місці. Ця технологія популярна в Іспанії, оскільки сприятливий клімат і характеристики ґрунту, погодні умови та інші фактори дозволяють не турбуватися про необхідність фундаменту і додаткових укріплень.

      `,
  },

  {
    id: 4,
    title: 'Які міфи про модульні будинки варто розвінчати?',
    description:
      `
     "Модульні будинки виглядають шаблонно". При будівництві нового будинку з нуля є можливість спроектувати його повністю, враховуючи всі побажання майбутнього власника. Однак у випадку з модульними будинками відповідь не така однозначна. Складність реалізації ідеї, якість оздоблення, площа впливатимуть на вартість житла. Хоча оздоблення відповідно до побажань клієнта можливе, компанії часто пропонують вже готові моделі. Якщо відступити від класичного дизайну, ціна може зрости, а час створення збільшиться.
"Розширити будинок неможливо". Як модульні, так і традиційні будинки можна розширювати, якщо це дозволяє конструкція, закони та місцевість. Багато модульних будинків спроектовані таким чином, що модулі можна додавати і розширювати. Це дозволяє легко додати додатковий простір. Розширення традиційного будинку є більш складним і трудомістким процесом.
"Модульні будинки - це не про міцність і надійність". При дотриманні всіх вимог і регулярному обслуговуванні модульні будинки можуть прослужити від 50 до 70 років, так само, як і будинки, побудовані традиційним способом.
"Проста коробка без жодних відмінних рис". Раніше модульні будинки вважалися занадто простими на вигляд. Однак сьогодні вони є прикладом сучасного стилю. Традиційні будинки можуть мати будь-який вигляд, залежно від смаку та стилістичних уподобань їхніх власників.


      `,
  },

{
    id: 5,
    title: 'Які ключові переваги модульних будинків в Іспанії?',
    description:
      `
     Однією з великих переваг модульних будинків є відсутність будівельного бруду. Більшість робіт виконується за межами будівельного майданчика. Коли модулі доставляють на будівельний майданчик, їх просто збирають разом, і це не призводить до утворення великої кількості сміття або бруду. Це означає, що вам не доведеться турбуватися про розкидане будівельне сміття та прибирання після будівництва. По-друге, модульні будинки часто приваблюють своєю екологічністю та енергоефективністю. Це пов'язано з оптимізацією виробництва та використанням матеріалів з урахуванням екологічних факторів. Завдяки цьому модульні будинки можуть бути більш енергоефективними та екологічними. Крім того, такий підхід до будівництва зменшує кількість відходів і більш ефективно використовує ресурси. Модульні будинки пропонують широке розмаїття та високу якість використовуваних матеріалів. Наприклад, метал і бетон є найпопулярнішими матеріалами для будівництва модульних будинків в Іспанії. Модульні будинки в Іспанії вважаються тимчасовими спорудами, які не впливають на геодезію ділянки. Ще однією перевагою модульних будинків є мінімум бюрократії при їх будівництві. Щоб побудувати такий будинок, не потрібно отримувати дозволи або ліцензії, як у випадку з традиційними будинками. Це означає, що ви можете побудувати модульний будинок практично на будь-якій ділянці, навіть якщо вона не має дозволу на будівництво. Це дає вам більше гнучкості і спрощує вибір місця для вашого майбутнього будинку.


      `,
  },

];

export const SolarEnergy = [
  {
    id: 1,
    title: `Чи вигідно використовувати сонячні панелі?
`,
    description:
      `
      Так, в Іспанії встановлення сонячних панелей стає все більш привабливим і розумним вибором. Оцінюючи ефективність системи для приватного споживання електроенергії, слід враховувати, що термін служби сонячних панелей становить близько 25 років, а інвестиції зазвичай окупаються приблизно за 7 років. Це означає, що власники сонячних систем в Іспанії не тільки отримують доступ до чистої та відновлюваної енергії, а й мають можливість значно скоротити свої витрати на електроенергію протягом тривалого періоду часу. Більше того, сонячні панелі можуть зменшити залежність від коливань цін на енергоносії та пом'якшити вплив змін у вартості електроенергії.

      `,
  },

   {
    id: 2,
    title: `Чи можна уникнути високих цін на електроенергію?

`,
    description:
      `
     Сонце - безцінний ресурс. В Іспанії ціни на електроенергію зараз майже втричі вищі, ніж у середньому за останні п'ять років. Завдяки великій кількості сонячного світла, Іспанія покладається на сонячні панелі як альтернативне джерело енергії. Окупність набагато швидша, ніж у Великобританії чи Швеції.


      `,
  },
   
   {
    id: 3,
    title: `Яким буде майбутнє сонячної енергетики в Іспанії? 

`,
    description:
      `
    До 2030 року Іспанія планує забезпечити майже 75% виробництва енергії в країні з альтернативних джерел, тоді як зараз цей показник становить близько 47%. Іспанія прагне до сталого майбутнього, заснованого на екологічно чистих джерелах енергії.



      `,
  },
   
   {
    id: 4,
    title: `Чи складно обслуговувати сонячні панелі?


`,
    description:
      `
   Використання сонячних панелей передбачає простий і не особливо витратний процес обслуговування сонячних панелей. Звичайно, це трохи складніше, ніж нічого не робити, коли ваш будинок підключений до електромереж загального користування, але також не складніше, ніж з будь-якою іншою побутовою технікою - пральною машиною, холодильником, які потребують технічного обслуговування. Якщо ваша установка була придбана у перевірених постачальників, то вам, як клієнту, пропонується повне сервісне обслуговування та ремонт сонячної установки. Ви можете самостійно протирати панелі від бруду і таким чином продовжити термін їх служби.




      `,
  },
   
   {
    id: 5,
    title: `Де ще затребувані сонячні панелі?



`,
    description:
      `
  У Китаї понад 40 мільйонів будинків вже обладнані сонячними водонагрівачами, що свідчить про високий попит на цю технологію. Пекін також встановив вражаючі 300 мільйонів квадратних метрів сонячних панелей до 2020 року. Іспанія також вживає активних заходів у розвитку сонячної енергетики. З березня 2006 року всі нові будинки в Іспанії за законом повинні бути обладнані сонячними панелями. Однак світовим лідером з використання сонячної енергії на душу населення є Ізраїль. Ця країна демонструє прогрес, встановлюючи більше сонячних панелей на людину, ніж будь-яка інша країна.



      `,
  },
   
   {
    id: 6,
    title: `Чи актуальна сонячна енергія для гарячого водопостачання та опалення?




`,
    description:
      `
 Сонячна енергія дозволяє використовувати її як для опалення приміщень, так і для виробництва гарячої води. Сонячна енергія для виробництва гарячої води є одним з найефективніших способів використання цього джерела енергії. Однак для обігріву приміщень потрібна значно більша площа сонячних панелей, ніж для підігріву води. Важливо зазначити, що сонячне опалення вигідне взимку, коли потрібне додаткове тепло. У той же час, в літній період великі сонячні батареї необхідно захищати від перегріву. Тепла вода, нагріта сонячною енергією, може циркулювати в системах теплої підлоги або подаватися в радіатори для підтримки комфортної температури в приміщенні. Для досягнення найвищої ефективності система повинна бути розрахована на роботу при низьких температурах рідини, щоб максимально використовувати доступну сонячну енергію.


      `,
  },
   
   {
    id: 7,
    title: `Як довго можуть служити сонячні панелі?





`,
    description:
      `
Сонячні панелі мають вражаючий термін служби, який можна порівняти з іншими електронними пристроями. При правильному використанні та догляді вони можуть продовжувати працювати десятиліттями. Ключову роль у визначенні терміну служби відіграє коефіцієнт деградації сонячних фотомодулів, який залежить від якості та технологічності продукції. Оптимальний сценарій передбачає, що через 20-25 років сонячна установка буде виробляти близько 80-85% від початкової потужності. Тобто, вона продовжуватиме робити значний внесок у виробництво електроенергії. Важливо відзначити, що після закінчення цього терміну сонячні панелі не виходять з ладу миттєво. Вони можуть продовжувати функціонувати, але з деяким зниженням продуктивності. Навіть після закінчення гарантованого терміну служби сонячна установка може продовжувати працювати і приносити користь протягом додаткових років. Гарантії виробників також відіграють важливу роль. Зазвичай вони пропонують 5-річну гарантію на механічні пошкодження для продуктів середнього класу і 10-12 років для продуктів преміум-класу. Це означає, що покупець може бути впевнений у надійності та якості сонячних панелей протягом певного періоду часу.

      `,
  },
];

export const Inmobiliaria = [
  {
    id: 1,
    title: `Чому важливо проводити аналіз ґрунту та рельєфу?

`,
    description: `
Рельєф місцевості та ґрунт визначають фундаментальні властивості ділянки, такі як її стабільність та здатність підтримувати споруду.
Геологічні та геотехнічні дослідження, проведені фахівцями, допомагають визначити, чи придатний ґрунт для будівництва. Наші фахівці перевіряють щільність ґрунту, його несучі властивості та стійкість до деформацій. Це важливо для того, щоб гарантувати, що вашій будівлі не загрожує небезпека просідання, обвалу або зсуву.
Експерти Moderna Casa кажуть, що рельєф і ґрунт також відіграють важливу роль у водовідведенні та водопостачанні ділянки. Правильне планування і розміщення будинку на ділянці дозволяє уникнути проблем із застоєм води і неправильним відведенням стічних вод. Таким чином, можна визначити оптимальні місця для розміщення систем водовідведення та каналізації.
Рельєф місцевості та ґрунт можуть впливати на планування та архітектуру будівлі. Нерівності рельєфу можуть вимагати додаткових земляних робіт і терасування ділянки, щоб створити рівний майданчик для будівництва. А проаналізувавши його заздалегідь за допомогою нашого сервісу нерухомості, ми зможемо сказати вам більш точну вартість послуг.
Знання ґрунту дозволяє вибрати найкращі методи фундаменту, адаптовані до конкретних умов ділянки. Наприклад, рівна ділянка може надати можливості для подальшого будівництва або створення садового простору.


      `,
  },

  {
    id: 2,
    title: `Як провести порівняльний аналіз декількох ділянок, щоб вибрати правильну?

`,
    description: `
Розробіть перелік критеріїв, за якими порівнюватимуться ділянки. Ці критерії можуть включати доступність, вартість землі, інфраструктуру, екологічні фактори, потенціал для майбутнього розвитку тощо. Визначте важливість кожного критерію, щоб виділити найбільш значущі аспекти.
Зберіть усі наявні дані для кожної ділянки, включаючи плани, карти, інфраструктуру, екологічну оцінку, а також ціни на землю та дозволи.
Проаналізуйте кожен сайт, використовуючи заздалегідь визначені критерії оцінки. Оцініть кожен критерій за шкалою або рейтинговою системою. Ви можете використовувати цифри або рейтинги, щоб зробити порівняння більш об'єктивним.
Враховуючи важливість кожного критерію, призначте їм коефіцієнти значущості. Наприклад, якщо доступність є найважливішим критерієм, ви можете надати йому більшої ваги, ніж іншим факторам.
Проаналізуйте оцінки для кожного розділу та врахуйте вагу критеріїв. Порівняйте результати і визначте, яка ділянка має найвищий загальний бал. Це і буде найбільш підходяще місце для будівництва.
Окрім бенчмаркінгу, необхідно враховувати бюджет проекту, юридичні обмеження, місцеві правила та дозволи. Послуга "Нерухомість" також передбачає цей вид аналізу. Наші експерти спеціалізуються на ринку 
нерухомості і допоможуть вам з аналітикою та збором усіх необхідних матеріалів.

      `,
  },

  {
    id: 3,
    title: `Як ми проводимо аналітику інфраструктури?

`,
    description: `
Ця послуга також включає аналіз інфраструктури. На що ми звертаємо увагу:
Навчальні заклади для дітей, такі як школи та дитячі садки.
Аптека, бажано відкрита 24/7.
Лікарня або відділення невідкладної допомоги, принаймні в безпосередній близькості.
Ветеринарна клініка, необхідна для фермерів, які хочуть придбати будинок в Іспанії для вирощування сільськогосподарських культур і розведення худоби.
Наявність асфальтованої дороги, що полегшує доступ до ділянки.
Відстань до найближчого населеного пункту.
Близькість автомобільного та залізничного вокзалів для зручного транспортного сполучення.
Продуктові магазини, ринки та торгові центри для зручності щоденних покупок.
Розважальні заклади, парки та сквери для відпочинку та дозвілля.
Наявність захисних споруд від можливих затоплень у разі повеней.
Кількість і тип прилеглих до ділянки доріг, а також завантаженість маршруту в різні дні і пори року. Наприклад, якщо найближча лікарня знаходиться за 15 кілометрів від ділянки і до неї потрібно їхати ґрунтовою дорогою, це може бути неприємним мінусом. Послуга "Нерухомість" допомагає проаналізувати можливий рівень комфорту, який можна надати покупцеві ділянки.

      `,
  },

  {
    id: 4,
    title: `Для чого потрібне тестування підземних вод?


`,
    description: `
Вода становить потенційну небезпеку для будівельних конструкцій, особливо для фундаменту. Будинки, побудовані на ділянках з високим рівнем ґрунтових вод, піддаються щоденному впливу води, на відміну від будинків з низьким рівнем ґрунтових вод. Це може призвести до просідання фундаменту, тріщин у стінах, затоплення підвалів, появи цвілі та грибка. Вплив на фундамент спричиняють не лише самі ґрунтові води. Хімічні речовини, розчинені у воді (наприклад, сульфати, солі), також можуть мати серйозні наслідки. Вони можуть викликати розпушення і розчинення бетону, що проявляється у вигляді білого нальоту і розшарування фундаменту. Дренаж ділянки з високим рівнем ґрунтових вод допоможе запобігти всім цим негативним наслідкам. А комплексно оцінити ситуацію ще до закладання фундаменту допоможе сервіс Real Estate Service.


      `,
  },

  {
    id: 5,
    title: `Чому неможливо обійтися без аналізу місцевості?



`,
    description: `
Обираючи ділянку для будівництва, завжди звертайте увагу на рельєф. Експерти Moderna Casa стверджують, що горбиста місцевість може бути красивою в ландшафтному дизайні, але створює труднощі при будівництві будинку. Бажано вибирати рівну ділянку без вигинів і обривів. Піднесена ділянка є кращою, оскільки вона забезпечить захист від повеней і, як правило, має вищу ціну.



      `,
  },

  {
    id: 6,
    title: `Чому не обійтися без послуги "Нерухомість"?




`,
    description: `
На підготовчих етапах завжди виникає багато труднощів, а всі найнебезпечніші підводні камені часто виявляються через деякий час. Завдання наших експертів - допомогти вам розпізнати ці ризики. Якщо в майбутньому ви вирішите продати земельну ділянку, слід врахувати фактори, що впливають на її вартість:
Наявність багатоповерхових будинків в радіусі 150 метрів. Висота будівель дозволяє мешканцям спостерігати за навколишньою територією, що може викликати певне занепокоєння.
Близькість ангарів та ферм. Це може призвести до зайвого шуму та неприємних запахів, пов'язаних з тваринництвом.
Занедбані будівлі. Вони можуть стати місцем проживання людей з низькою соціальною відповідальністю, що створює потенційні проблеми з безпекою та навколишнім середовищем.
Наявність кладовищ. Деякі покупці можуть сприймати їх як небажаний елемент, що впливає на естетику та екологію прилеглої території.
Близькість ліній електропередач (ЛЕП). Деякі дослідження пов'язують їх з можливим впливом на здоров'я, що може відлякувати покупців.
Наявність гаражних кооперативів. Вони можуть впливати на загальну атмосферу і візуальний вигляд навколишньої забудови. Врахування всіх цих факторів при купівлі нерухомості зменшить ймовірність виникнення проблем під час подальшого продажу. А наші експерти допоможуть вам пройти цей шлях разом з вами.




      `,
  },
];

export const Consulting = [
  {
    id: 1,
    title: `Що таке консалтингові послуги на ринку нерухомості в Іспанії?

`,
    description: `
Це можливість проконсультуватися з компетентними людьми і довірити експертам аналіз поточної ситуації на ринку та інших питань, які прямо чи опосередковано пов'язані з нерухомістю в Іспанії. Цей аналіз є професійною оцінкою інфраструктури існуючої або запланованої будівлі. Його основна мета - виявити вразливі місця і неправильну експлуатацію об'єкта, які можуть призвести до недостатньої прибутковості. Експерти також аналізують будівлі, які перебувають лише на стадії планування. В результаті цього процесу виявляються недоліки, які після їх виправлення зроблять об'єкт більш привабливим для мешканців, клієнтів та орендарів.


      `,
  },
  {
    id: 2,
    title: `Що включає в себе комплексний консалтинг?


`,
    description: `
Проектний консалтинг включає в себе кілька важливих компонентів. По-перше, оцінюється ринок, цільова аудиторія та купівельна спроможність потенційних клієнтів, для яких планується будівництво об'єкта. Це допомагає визначити актуальність проекту та його комерційну життєздатність. По-друге, проводиться оцінка естетичної та планувальної грамотності приміщень і аналіз попиту на таке архітектурне рішення серед потенційних клієнтів. Це важливо для створення привабливого та комфортного простору, що відповідає потребам майбутніх користувачів. Третій аспект включає перевірку технічної документації на відповідність нормам і стандартам, щоб гарантувати безпеку і якість будівництва. Також проводяться дослідження очікувань населення, яке проживає поблизу проекту, щоб врахувати їхні потреби і надати найбільш відповідні послуги та зручності. Важливим етапом є перевірка дотримання законів і нормативних актів, щоб проект мав усі необхідні дозволи. Після отримання наших консультаційних послуг можна переходити до етапів проектування та будівництва будинку, які також забезпечують наші фахівці. На завершення формується концепція будівлі та розробляється маркетинговий план. Сюди входить визначення унікальних особливостей і переваг проекту, а також стратегій маркетингу і просування для залучення зацікавлених клієнтів і успішного виведення нерухомості на ринок.
      `,
  },

  {
    id: 3,
    title: `Що включає в себе юридичний консалтинг?



`,
    description: `
Нерухомість - це складна і регульована сфера з різними законами, правилами і процедурами, яких необхідно дотримуватися. Юридичні консультації у сфері нерухомості мають велике значення для захисту прав та інтересів клієнтів, а також для забезпечення успішних угод та операцій. Якщо в рідній країні покупцеві або інвестору простіше розібратися в правилах і законах самостійно, то іноземним інвесторам в нерухомість в Іспанії варто дізнатися про підводні камені від експертів. Однією з головних причин звернення за юридичною консультацією є забезпечення правової безпеки. Юристи аналізують документи і транзакції, щоб переконатися в їх законності, і попереджають про можливі юридичні ризики. Вони допомагають клієнтам уникнути несподіваних проблем і суперечок, пов'язаних з нерухомістю, а також надають поради та рішення для вирішення юридичних питань. Юридична консультація необхідна для правової експертизи документів. Сюди входить перевірка договорів купівлі-продажу, оренди, актів на землю та інших правовстановлюючих документів. Правильність і повнота документації є запорукою успішної операції з нерухомістю, а юристи допомагають клієнтам уникнути можливих помилок і проблем, пов'язаних з неправильно оформленими документами. Наші фахівці пояснюють складні юридичні терміни та процедури, правила та закони, що регулюють сферу нерухомості, а також допомагають клієнтам зрозуміти їхні права та обов'язки. Вони рекомендують найкращі практики та стратегії для досягнення бажаних результатів і попереджають про потенційні ризики.

      `,
  },

  {
    id: 4,
    title: `Які найпоширеніші запити ми отримуємо?



`,
    description: `
Усні погодинні консультації, під час яких наші експерти відповідають на ваші запитання та надають поради щодо різних аспектів нерухомості.
Інвестиційний консультаційний висновок, який допоможе вам прийняти обґрунтоване рішення про інвестування в нерухомість та оцінити потенційну віддачу від ваших інвестицій.
Маркетингові дослідження ринків нерухомості охоплюють житлову, офісну, торговельно-розважальну, готельну та індустріально-складську нерухомість. Ми аналізуємо попит, пропозицію та конкуренцію на цих ринках, допомагаючи вам зрозуміти потенціал та перспективи розвитку різних сегментів нерухомості.
Послуги з концептуального планування, які допомагають розробити ефективні та інноваційні концепції будівництва та розвитку нерухомості, враховуючи ринкові фактори, економіку, потреби клієнтів та законодавчі вимоги.
Експрес-аналіз ситуації у форматі професійного висновку, який надає оперативну та об'єктивну оцінку поточної ситуації та рекомендації щодо подальших дій.
Підготуйте інвестиційний меморандум, який описує проект, його потенціал, ризики та очікувані результати для залучення потенційних інвесторів.
Аналіз містобудівної документації та перспектив розвитку проекту, який включає вивчення містобудівних планів, узгодження з вимогами державних органів та оцінку перспектив реалізації проекту.

      `,
  },
];




export const SmartHome = [
  {
    id: 1,
    title: `Розумний будинок: встановлювати систему чи ні?
`,
    description:
      `Розумний будинок - це не просто технологічна новинка, а сучасний стиль життя, який став новою нормою у світі нерухомості в Іспанії. Розумний будинок робить ваше життя зручним, ефективним і приємним, а також демонструє передові технології прямо у вашій оселі. Система домашньої автоматизації дозволяє значно скоротити споживання енергії в квартирі. Завдяки відеоспостереженню ви можете легко контролювати безпеку ваших дітей та вашого будинку, навіть коли ви перебуваєте далеко від дому. А які здивовані погляди чекають на ваших друзів, коли ви закриваєте жалюзі лише однією фразою, наприклад, "Siri, кіно", потім вимикаєте світло, а плеєр вмикає ваш улюблений серіал - це просто магія. Рятівний тренд, покликаний допомогти оптимізувати різні побутові процеси.
`,
  },
  {
    id: 2,
    title: `Чи можу я сам розібратися в системі?
`,
    description:
      `Однозначно так. Адже "Розумний будинок" просто створений для того, щоб спростити життя кожної людини. Наші фахівці допоможуть клієнту розібратися в принципах роботи різних систем ще на етапі вибору. Після контактного тестування обладнання в шоу-румі всі сумніви у потенційного власника повністю зникають. Вже за тиждень ви звикнете до свого нового помічника і не зможете уявити життя без нього.
`,
  },
   {
    id: 3,
    title: `Чи будуть проблеми з ремонтом, якщо у вас є система розумного будинку?

`,
    description:
      `
      Все залежить від лікування та стадії ремонту. Бажано повідомити про готовність системи до початку оздоблювальних робіт, щоб врахувати необхідність прокладання кабелів. Наші фахівці допоможуть вам встановити систему як на початковому етапі будівництва будинку, так і після монтажу системи в готовому будинку. Фахівці врахують особливості монтажу системи та уникнуть встановлення зайвих елементів у будинку.

`,
  },
   
   {
    id: 4,
    title: `З яких етапів складається установка системи розумного будинку?


`,
    description:
      `
     Інсталяція здійснюється в два етапи: перший - після завершення чорнових будівельних робіт, включаючи прокладку кабелів; другий - після завершення чистових робіт і включає в себе підключення та налаштування системи. Зазвичай весь процес інсталяції займає близько тижня, але час може змінюватися в залежності від складності та обсягу необхідного функціоналу.

`,
  },
   
   {
    id: 5,
    title: `Скільки часу займає процес встановлення розумного будинку?



`,
    description:
      `
     Процес встановлення системи займе не більше двох тижнів, за умови дотримання наступних вимог:
Завершення чистового оздоблення приміщень та відсутність інших робіт, які можуть завадити монтажу.
Забезпечення повноцінного функціонування каналізації, електро- та водопостачання в приміщенні.
Вільний доступ до електричних щитів, які дозволяють відключати лінії електропередач, до яких підключено обладнання.
Наявність безперешкодного доступу до всіх точок встановлення компонентів системи.
Підтримання стабільної температури в приміщенні від +18° до +30°. Враховуючи ці умови, фахівці встановлять систему в зазначені терміни, гарантуючи оперативність і високу якість робіт.

`,
  },
   
   {
    id: 6,
    title: `Що станеться зі споживанням електроенергії?




`,
    description:
      `
    На превеликий подив багатьох наших клієнтів, системи розумного будинку споживають дуже мало електроенергії, і навіть допомагають зменшити рахунки (приблизно на 30%), попереджаючи їх про непотрібні перевитрати. Наприклад, датчики руху допомагають уникнути зайвого споживання електроенергії. Але найбільшої економії можна досягти в управлінні кліматичною системою. На додаток до системи розумного будинку ви можете замовити у нас сонячні панелі, щоб отримати комплексні переваги, бути екологічно чистим, заощадити власні кошти і максимально розкрити потенціал свого будинку.

`,
  },
   
   {
    id: 7,
    title: `Що відбувається з будинком, коли відключають інтернет?

`,
    description:
      `
   Розумні будинки мають дротові системи, які функціонують незалежно від підключення до Інтернету. Якщо мережеве з'єднання буде втрачено, "розумний дім" продовжить працювати у звичайному режимі завдяки передбаченій інженерії, узгодженій з роботою побутових приладів. Єдині системи, які можуть відчувати деякі обмеження, - це бездротові. Однак варто подумати про придбання джерела безперебійного живлення на випадок перебоїв в електропостачанні, що також корисно для всіх побутових приладів.

`,
  },
   
   {
    id: 8,
    title: `Чи можна керувати системою вручну?


`,
    description:
      `
 Так, залишити управління системою в ручному режимі можливо, особливо якщо потрібно забезпечити безпеку маленької дитини або людини похилого віку. Таким чином, є гарантія, що плита на кухні не запалиться помилково. Однак, завдяки інтуїтивно зрозумілому інтерфейсу, ви можете легко освоїти функціонал управління протягом дня. Ви можете обрати простіший спосіб використання системи та скористатися додатком на телефоні.

`,
  },
   
   {
    id: 9,
    title: `Розумний будинок: чи підходить ця система тільки для житла?



`,
    description:
      `
Ця інноваційна технологія ідеально підходить для житлових будинків, офісів, корпоративних будівель і бізнес-центрів. Система може запропонувати багато переваг для вашого бізнесу: від надійної системи безпеки до дистанційного керування освітленням, опаленням, шторами та жалюзі. Планування та встановлення таких систем найкраще здійснювати до початку ремонту або якомога раніше. Однак, незалежно від того, чи це новий ремонт, чи вже існуюче приміщення, досвідчені фахівці Moderna Casa, які знаються на встановленні розумних технологій, зроблять все можливе, щоб мінімізувати будь-які негативні наслідки з боку будівлі та запропонують вам найкраще рішення з урахуванням специфіки вашої ситуації.

`,
  },
];

export const SwimmingPools = [
  {
    id: 1,
    title: "Що можна додати до пулу?",
    description:
      `Установка "штучного водного потоку". Відмінний варіант для тих, хто любить фізичну активність. Навіть у невеликих басейнах цей пристрій дозволяє одночасно займатися спортивним плаванням і насолоджуватися гідромасажем.
Донний гейзер пропонує кожному члену сім'ї повітряний масаж, який створює відчуття невагомості та збагачує воду киснем. Доповнення допоможе молодшим членам сім'ї швидше і впевненіше почати триматися на воді. А дорослі члени сім'ї будуть задоволені тим, що після такого масажу зникає втома, безсоння і поганий настрій.
Водоспад - це не тільки естетика і зовнішня краса, але й ефективний масаж для плечового поясу. Він також є ідеальним доповненням для створення атмосфери релаксації та насолоди в басейні. А опція підсвічування створить відчуття комфорту в темну пору доби.
Водна гірка - мрія всіх дітей. Вони можуть годинами невтомно кататися з гірки, насолоджуючись веселощами і розвагами. У каталозі нашої компанії ви знайдете широкий вибір аксесуарів для басейнів, а наші досвідчені фахівці допоможуть підібрати ідеальний варіант, що відповідає вашим вимогам і побажанням. Ми пропонуємо тільки найякісніші та функціональні атракціони. Наші фахівці знають, як зробити ваш басейн нетривіальним і функціональним рішенням.
`,
  },
  {
    id: 2,
    title: "Вибираємо тип басейну: скіммер або переливний?",
    description:
      `
      скіммер басейн: вода фільтрується через поверхневі скімери і повертається через настінні форсунки.
Переливний басейн: вода заливається в накопичувальний бак, проходить через системи фільтрації, підігріву та дезінфекції і повертається через донні форсунки. Вибір типу басейну залежить від вас, але якщо у вас є можливість і бюджет, то кращим варіантом є пейзажний басейн. Однак, скіммерний басейн також може бути дуже якісним, якщо дотримуватися всіх необхідних розрахунків і технологій. Ми готові допомогти вам встановити будь-який басейн.

      `,
  },
  {
    id: 3,
    title: `Які можливості існують для автоматизації та управління басейном?`
,
    description:
      `Якщо ви уважно подивитеся на наші послуги, то побачите таку послугу, як "розумний дім". Вона призначена не тільки для використання всередині будинку, але і для зовнішніх елементів.
Механізм дозволяє автоматизувати процеси фільтрації та підтримки якості води в басейні. Ви можете контролювати і регулювати роботу фільтрів, насосів, систем дезінфекції та підігріву води через додаток на смартфоні або панель управління.
Система "розумний дім" дозволяє інтелектуально керувати температурою води в басейні. Ви можете встановити бажану температуру за допомогою мобільного телефону, і система буде автоматично підтримувати її, в тому числі вмикати і вимикати водонагрівачі.
Кожна людина отримує можливість керувати освітленням навколо басейну, включаючи підводне освітлення, за допомогою системи "розумний дім". Таким чином створюючи різні атмосфери та настрої навколо басейну.
Безпека та сигналізація - ще одна перевага. Ви можете отримувати сповіщення про стан басейну, наприклад, про зміну рівня води або виявлення руху навколо басейну, щоб уникнути нещасного випадку.
Налаштуйте розклад для системи басейну та створіть автоматичні сценарії. Наприклад, ви можете налаштувати ввімкнення та вимкнення систем фільтрації та підігріву, а також створити сценарії, які вмикатимуть освітлення та фонову музику під час використання басейну. Це лише кілька прикладів того, що можуть зробити системи розумного будинку для автоматизації та управління вашим басейном. Звернувшись до нас, ми допоможемо вам отримати максимальну вигоду від інтеграції механізму автоматизації.
`,
  },

  {
    id: 4,
    title: `Які матеріали найкраще підходять для обробки внутрішньої поверхні басейну?`
,
    description:
      `
      Найбільш підходящими матеріалами для внутрішнього оздоблення басейну є
Керамічна плитка - популярний і довговічний матеріал для оздоблення басейну. Вона має хорошу стійкість до води, хімічних речовин і ультрафіолету, а також легко чиститься.
Склопластик вважається довговічним матеріалом. Воно створює гладку поверхню і забезпечує хороший захист від корозії та ультрафіолету.
Епоксидна смола гарантує довговічне і водонепроникне покриття для басейнів. Вона має високу хімічну стійкість і витримує великі навантаження.
ПВХ-мембрана - це гнучкий матеріал, яким можна покрити внутрішню поверхню басейну. Вони мають високу стійкість до хімічних речовин і прослужать довгий час.
Поліуретанова фарба широко використовується для оздоблення басейнів. Вона забезпечує гладку і міцну поверхню, стійку до хімічних речовин і ультрафіолетового випромінювання. Ми рекомендуємо проконсультуватися з нашими фахівцями, щоб вибрати правильний матеріал відповідно до ваших потреб і умов басейну.

`,
  },

  {
    id: 5,
    title: `Які види обслуговування та догляду потрібні для басейну?`
,
    description:
      `
     Для забезпечення належного функціонування та якості басейну необхідні наступні послуги та технічне обслуговування:
Видалення сміття, листя та інших відходів з басейну за допомогою сітки або пилососа для басейну.
Перевірка та корекція рівня хлору, pH-балансу та інших хімічних показників води. Забезпечення безпеки води та запобігання розмноженню шкідливих бактерій і водоростей.
Перевірка та очищення фільтра басейну. Фільтр видаляє з води дрібні частинки і домішки, а його регулярне очищення допомагає підтримувати ефективну роботу системи фільтрації.
Обслуговування системи водяного опалення (якщо вона встановлена). Це може включати перевірку та обслуговування опалювального обладнання, такого як котли, теплові насоси або сонячні колектори.
Перевірка та обслуговування насоса для басейну. Насос забезпечує циркуляцію води в басейні і потребує технічного обслуговування для ефективної фільтрації та очищення води.
Контроль всіх систем безпеки, включаючи наявність і працездатність плоттера (рятувального круга), вимикачів і сигнальних пристроїв. Ці послуги та обслуговування є важливими для підтримки басейну в безпеці, чистоті та правильній роботі. Тому ми готові бути вашими надійними помічниками на цьому шляху і надавати систематичні якісні послуги.

`,
  },

  {
    id: 5,
    title: `Як забезпечити безпеку в басейні, особливо для дітей?`
,
    description:
      `
    Для нас важливо не тільки продати вам басейн, але і гарантувати високу безпеку для кожного члена сім'ї. Для цього необхідно вжити наступних заходів:
Встановіть надійну огорожу навколо басейну, яка запобігатиме несанкціонованому доступу дітей до води.
Якщо неможливо спостерігати за басейном, використовуйте захисні накриття, такі як плотери (рятувальні круги) або накриття для басейну, щоб запобігти випадковому падінню дітей у воду.
Дорослі завжди повинні знаходитися поруч з дітьми біля басейну. Регулярний і пильний нагляд дорослих може запобігти небезпечним ситуаціям.
Розкажіть дітям про правила безпеки в басейні. Важливо пояснити, що вони не повинні гратися біля басейну без дорослих або стрибати у воду без дозволу.
Рятувальні засоби, такі як плотики, буйки або рятувальні круги, завжди повинні бути в наявності біля басейну. У разі надзвичайної ситуації вони можуть бути використані для надання допомоги. Напишіть нам, і ми підкажемо, як зробити ваш басейн практичним, красивим і продуманим, а також безпечним для всіх.

`,
  },

  {
    id: 6,
    title: `Чи можу я сам вибрати обладнання для басейну?
`
,
    description:
      `
   Самостійний підбір обладнання для басейну можливий, але для цього потрібно вирішити серйозні проблеми. Потрібно вивчити безліч книг і документів, розібратися в принципах водопідготовки, розрахувати діаметри трубопроводів і швидкість руху води, правильно підібрати обладнання та багато іншого. Це не можна назвати можливістю заощадити, оскільки ви повинні інвестувати значну частину свого часу. Співпраця з компанією Moderna Casa, яка спеціалізується на поліпшенні експлуатаційних характеристик вашого будинку і продажу обладнання для басейнів, гарантує конкурентоспроможні ціни і якісну продукцію.

`,
  },
];

export const Investments = [
  {
    id: 1,
    title: `Чи варто інвестувати в друге житло?
`,
    description:
      `Другі дані про ціни на житло в Іспанії за січень 2023 року, надані індексом цін на нерухомість Idealista, дозволяють нам ближче познайомитися з ситуацією. В середньому ціни на вторинне житло зросли на 5,4%, досягнувши рівня 1 922 євро за квадратний метр. Незважаючи на це, загальнонаціональне зростання цін на житло залишилося нижчим за рівень інфляції в 5,8% у січні. Якщо поглянути на столиці Іспанії, то можна побачити, що в 16 містах зростання цін на друге житло перевищило рівень інфляції. Найбільш значне зростання було зафіксовано в Санта-Крус-де-Тенеріфе (+18,7%), Аліканте (+13,2%), Валенсії (+11,4%), Гвадалахарі (+11,3%), Куенці (+10,8%), Пальмі (+9,9%), Севільї (+8.1%), Малага (+8%), Сеговія (+9,9%), Понтеведра (+8,3%), Бадахос (+7,3%), Уельва (+7,2%), Ла-Корунья (+6,8%), Таррагона (+6,6%), Гранада (+6,3%) і Памплона (+5,8%). Крім того, ще в 30 столицях спостерігалося зростання цін на житло, але вони залишалися нижчими за рівень інфляції. Серед цих міст слід виділити великі ринки Мадрида (+4,9%) та Барселони (+3%). Січень 2023 року приніс зміни в цінах на друге житло в Іспанії, спостерігається зростання цін. Тому рішення придбати об'єкт сьогодні і перепродати його пізніше може забезпечити відмінну фінансову подушку для інвестора.
`,
  },

   {
    id: 2,
    title: `Які додаткові переваги отримує інвестор в Іспанії?

`,
    description:
      `Іспанія пропонує одну з найпривабливіших програм для отримання посвідки на проживання (ПНП), а згодом і громадянства. Щоб стати учасником програми, необхідно придбати нерухомість вартістю не менше 500 000 євро, а проживши в країні 10 років, ви зможете подати заяву на отримання громадянства ЄС з усіма пов'язаними з цим перевагами. Іспанія є привабливим напрямком для інвестицій в нерухомість, особливо для країн з нестабільною економікою. Ця країна посідає четверте місце за рівнем економіки в Єврозоні та дванадцяте у світовій економіці. Інвестувати в нерухомість тут вигідно і надійно. Різні експерти оцінюють прибутковість таких інвестицій в діапазоні від 5 до 15% річних. Особливо привабливими для інвесторів є квартири або таунхауси на популярних курортах. Це пов'язано з величезною популярністю Іспанії серед туристів з усього світу. Тут вдало синхронізувалися відмінний клімат, красиве середземноморське узбережжя, високий економічний і соціальний розвиток, багата культурна спадщина. Всі ці фактори роблять Іспанію дуже привабливою для інвестицій в нерухомість.

`,
  },
   
    {
    id: 3,
    title: `Чому обирають нас для інвестування?


`,
    description:
      `Багато людей вирішують інвестувати самостійно, але потребують більше знань, щоб робити це безпечно і грамотно. Тому без надійного помічника не обійтися. Ми спеціалізуємося на розробці та реалізації оптимальних рішень для інвесторів в Іспанії. Наша мета - допомогти вам отримати високий пасивний дохід. Ми аналізуємо економічні перспективи інвестування в нерухомість Іспанії і допомагаємо нашим клієнтам вигідно вкласти свої гроші. Ми прагнемо створити інвестиційний портфель з високою стратегічною точністю, враховуючи всі потенційні ризики для інвестора. Ми надаємо повний комплекс послуг для забезпечення високого доходу на ринку нерухомості Іспанії. Більше половини наших клієнтів довіряють нам управління і комплексне адміністрування після завершення угоди. А ми регулярно відстежуємо законодавчі нововведення, щоб забезпечити безпеку ваших коштів і відповідність законам.

`,
  },
    
     {
    id: 4,
    title: `Які характеристики найприбутковіших об'єктів нерухомості?



`,
    description:
      `При виборі нерухомості є ключові критерії, на які слід звертати увагу. Одним з таких критеріїв є прекрасний панорамний вид на море або природу з вікна, який не можна недооцінювати. Дослідження TripAdvisor показало, що для 82% мандрівників надихаючий вид з вікна є найважливішою частиною їхньої подорожі. Тому залучення відвідувачів і покупців будинків для відпочинку вимагає значних зусиль. Крім того, іспанські міські квартири в інших районах виграють за рахунок зручностей і відмінної транспортної інфраструктури поблизу. Враховуйте додаткові критерії при виборі другого будинку як інвестиції в нерухомість. Незалежно від того, чи ви здаєте нерухомість в оренду, чи плануєте її продати, наявність належних функцій та зручностей має важливе значення. Сучасні зручності, такі як швидкий Wi-Fi, телевізори високої чіткості, чисті, стильні ванні кімнати та загальні приміщення, можуть значно підвищити привабливість будинку для відпочинку. У теплому кліматі часто додають цінності обідні зони на терасі, зовнішнє освітлення або додаткові кімнати. Крім того, важливо точно оцінити витрати на утримання будинку, щоб гарантувати повернення інвестицій. Сюди входить облік витрат на прибирання, технічне обслуговування, садівництво та ремонт.

`,
  },
      {
    id: 5,
    title: `Інвестиції та Золота віза: які перспективи вони відкривають?




`,
    description:
      `Золота віза - це віза, яка дозволяє інвесторам з країн, що не входять до Європейського Союзу, та членам їхніх сімей стати резидентами Іспанії. Ваші найближчі родичі, включаючи подружжя та неповнолітніх дітей, отримають право на проживання в Іспанії, якщо ви отримаєте Золоту візу. Це також стосується повнолітніх дітей, які перебувають на утриманні. Отримання Золотої візи в Іспанію дає вам можливість проживати в країні і користуватися багатьма перевагами, якими можуть користуватися тільки резиденти Іспанії. Хто може подати заяву на отримання Золотої візи в Іспанію? Будь-хто, хто купує житло на суму понад 500 000 євро, може подати заявку на отримання цієї візи за умови, що заявник вніс щонайменше цю суму власними коштами, інвестував у державні облігації або має акції чи банківські депозити на суму понад 1 000 000 євро. Також право на отримання цієї візи мають особи, які реалізують в Іспанії бізнес-проекти, що становлять суспільний інтерес. Це стосується всіх проектів, які створюють робочі місця і мають соціально-економічний вплив на географічну територію, де вони реалізуються, а також всіх проектів, які сприяють науковим або технологічним інноваціям в країні. Як довго діє Золота віза в Іспанії? За цією візою ви можете проживати в Іспанії щонайменше один рік. Після цього періоду ви можете подати заяву на отримання посвідки на проживання терміном на 2 роки. За умови наявності інвестицій та інших вимог, максимальний термін дії посвідки на проживання становить 5 років.

`,
  },
];

export const Construction = [
  {
    id: 1,
    title: 'Які типи приватних будинків у нас замовляють найчастіше?',
    description:
      `
     В Іспанії приватне житло привертає увагу своїми особливостями, які відрізняються від типових об'єктів цієї категорії в інших країнах ЄС. Тут популярні наступні типи будинків
      `,
  },

  {
    id: 2,
    title: 'Чи існують обмеження на будівництво?',
    description:
      `
      При будівництві приватного житла в Іспанії враховуються два основні параметри: максимально допустима висота будівлі та її габарити. Хоча законодавство визначає етапи будівництва, норми часто переглядаються. Земельна ділянка, призначена для будівництва, повинна мати спеціальний документ - Ficha Urbanistica, який містить основні допустимі характеристики об'єктів. У кожному регіоні також діють свої місцеві правила, які регулюють такі аспекти, як:
Максимальна висота приватних об'єктів;
Дизайн фасадів;
Стиль даху та інші характеристики. Ці стандарти зафіксовані в дозволі на будівництво, без якого будь-яке будівництво є незаконним.

      `,
  },

  {
    id: 3,
    title: 'Які фактори слід враховувати при плануванні внутрішнього простору будинку?',
    description:
      `
      Щоб ідеально спланувати простір, важливо проаналізувати всі потенційні характеристики майбутньої оселі. Наші експерти підготували для вас список рекомендацій:
Приміщення будинку повинні бути розділені на функціональні зони (житлові, господарські, громадські, приватні).
Раціональне розташування зон і зручні сполучення допоможуть підвищити комфорт і зменшити використання коридорів.
Житлові та ділові зони повинні бути відокремлені одна від одної.
Допоміжні приміщення повинні бути приховані, але доступні в будь-який час.
Приватні зони, такі як спальні, рекомендується ізолювати і ховати від громадського простору в дальніх кутках.
При плануванні будинку враховуйте склад сім'ї, вікові групи та спосіб життя.
Уникайте перетину брудних і чистих зон, щоб запобігти поширенню бруду. Наприклад, гараж повинен мати окремий вихід.
Об'єднуйте схожі за функціоналом приміщення та зонуйте їх за допомогою предметів інтер'єру.
Рекомендується два входи в будинок - головний і додатковий.
Враховуйте майбутні комунікації при розробці проекту. Планування дійсно має багато деталей, і тільки досвідчені фахівці зможуть грамотно підійти до зонування майбутнього житла. Звертаючись до нас, ви можете бути впевнені, що ми врахуємо ваші деталі і зробимо кожен квадратний метр вашого простору функціональним, продуманим, безпечним і ергономічним.

      `,
  },

  {
    id: 4,
    title: 'Які існують категорії земель?',
    description:
      `
      Коли ви вибрали ділянку, яка підходить вам за місцем розташування, розміром і ландшафтними уподобаннями, рекомендується звернутися до професійного архітектора і запросити звіт про категорію та особливості обраної ділянки. Існує три типи земельних ділянок, які слід розрізняти:
Суело Урбано: Ці ділянки знаходяться в межах міста і придатні для швидкої житлової забудови. Тут вже є дороги та необхідні комунікації (електрика, газ, вода).
Suelo urbanizable: будівництво на цих ділянках можливе лише після попередньої підготовки та затвердження детального плану муніципалітетом. Часто на таких територіях діють особливі вимоги до захисту навколишнього середовища.
Suelo no urbanizable: цей острів розташований у заповідній зоні, де будівництво житлових об'єктів заборонено, а ліцензія на це видається лише у виняткових випадках. Проводячи аналіз, архітектор повинен чітко описати всі обмеження, які поширюються на конкретну ділянку. Наприклад, це можуть бути суворі вимоги до відстані між сусідніми будинками, заборона на вирубку деяких старих дерев, труднощі з підключенням до електрики, газу, водопроводу.

      `,
  },

  {
    id: 5,
    title: 'Скільки часу займає процес будівництва?',
    description:
      `
      Виходячи з досвіду наших фахівців, будівництво будинку в Іспанії зазвичай займає приблизно 18 місяців і проходить у кілька ключових етапів. На початку процесу необхідно вибрати і придбати земельну ділянку, яка відповідає вимогам для будівництва. Далі слідує розробка основного проекту і підготовка детального кошторису на виконання робіт. Отримання необхідних дозволів від місцевих органів влади та сплата податків у муніципалітеті також є важливими кроками. Укладення договору з підрядною компанією та безпосереднє будівництво включає підведення комунікацій, будівництво фундаменту та внутрішнє оздоблення. В кінці процесу проводиться фінальна перевірка муніципалітету для отримання дозволу на експлуатацію, оформлення документів на власність, а також підключення електрики, води та освітлення в новому житлі. Звернувшись до нас, ми допоможемо вам зробити цей процес максимально комфортним і швидким.

      `,
  },

  {
    id: 6,
    title: 'Які документи потрібні для початку будівництва?',
    description:
      `Коли муніципалітет схвалить будівництво вашого приватного будинку, ваш архітектор може приступити до розробки детального плану та оцінки вартості матеріалів і робіт (PEM - El Presupuesto de Ejecución Material). Потім вам потрібно знайти надійну будівельну компанію, з якою ви укладете договір, і для цього вам знадобляться наступні документи:
Licencia de obra mayor (дозвіл на основне будівництво) від Ayuntamiento (муніципалітету).
Документи, що підтверджують ваше право власності на землю.
Перевірка технічної можливості підключення до централізованих комунікацій.
Детальний проект будівлі.
Копії генерального плану забудови території.
Акт із зазначенням меж ділянки та існуючих будівель. Після отримання офіційних кошторисів та дозволів можна розглядати можливість отримання фінансування в банку. Однак слід пам'ятати, що отримання великого кредиту, що покриває всі витрати на будівництво, лише іноді доступне приватним особам. Спираючись на свій досвід будівництва будинку в Іспанії, багато людей попереджають, що кредити на такі проекти приватним особам можуть видаватися з певними обмеженнями.

      `,
  },
];

export const Projects = [
  {
    id: 1,
    title: 'Які типи послуг ви пропонуєте?',
    description:
      "Ми пропонуємо широкий відео послуг з будівництва та нерухомості, включаючи, але не обмежуючись: будівництвом, дизайном інтер'єру, модульними будинками, басейнами, сонячною енергією, розумними будинками, інмобільярія, інвестиціями та консалтингом.",
  },
  {
    id: 2,
    title: 'Що зробила ваша компанія',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec venenatis blandit ligula. Etiam a feugiat mauris. Duis et elit et enim blandssit volutpat. Sed et lobortis turpis. Curabitur ac neque sed massa ultricies tristique. Nunc faucibus vel justo quis accumsan. Maecenas gravida lacus eget faucibus mollis. Donec mattis nisl quis pretium facilisis. Praesent ultricies orci dignissim, tempor felis et, rhoncus dolor.',
  },
  {
    id: 3,
    title: 'Який ваш модель ціноутворення?',
    description:
      'Sed in tellus vestibulum, convallis nisl a, tincidunt lectus. Nulla auctor diam volutpat nisi luctus, sed dapibus augue laoreet. Mauris pretium nisi sed luctus gravida. Donec in vehicula urna. Phasellus metaus ex, faucibus vitae tortor vitae, malesuada varius neque. Donec vel metus ornare, iaculis nunc sed, tempor lectus. Morbi sagittis erat et arcu dictum, in aliquam risus lobortis. Aliquam pulvinar, ipsum porttitor lacinia fringilla, quam orci scelerisque neque, nec tempor neque leo tempus sem. Praesent eget nulla nec nulla fermentum ornare. Quisque porta fringilla ipsum vel vehicula. Duis vel mattis ligula, at interdum diam.',
  },
  {
    id: 4,
    title: 'Як можна розпочати проект?',
    description:
      'Phasellus maximus porta fermentum. Vivamus ut imperdiet enim, non convallis arcu. Mauris blandit vel leo ut lacinia. Praesent et cursus quam.ft Maecenas interdum semper orci nec mattis. Integer in blandit lacus. Proin viverra erat condimentum dolor commodo, a iaculis risus tristique. Phasellus sed dapibus nunc, accumsan sollicitudin enim.',
  },
  {
    id: 5,
    title: 'Чи пропонуєте ви будь-які гарантії або гарантії для вашої роботи?',
    description:
      'Suspendisse laoreet eros acq orci ornare, id eleifend mauris laoreet.',
  },
  {
    id: 6,
    title: 'Які види послуг ви пропонуєте?',
    description:
      "Ми пропонуємо широкий спектр послуг у сфері будівництва та нерухомості, включаючи, але не обмежуючись: будівництво, дизайн інтер'єру, модульні будинки, басейни, сонячна енергетика, розумні будинки, Inmobiliaria, інвестиції та консалтинг.",
  },

  {
    id: 7,
    title: 'Що зробила ваша компанія',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec venenatis blandit ligula. Etiam a feugiat mauris. Duis et elit et enim blandit voluqtpat. Sed et lobortis turpis. Curabitur ac neque sed massa ultricies tristique. Nunc faucibus vel justo quis accumsan. Maecenas gravida lacus eget faucibus mollis. Donec mattis nisl quis pretium facilisis. Praesent ultricies orci dignissim, tempor felis et, rhoncus dolor.',
  },
  {
    id: 8,
    title: 'Яка ваша модель ціноутворення?',
    description:
      'Sed in tellus vestibulum, convallis nisl a, tincidunt lectus. Nulla auctor diam volutpat nisi luctus, sed dapibus augue laoreet. Mauris pretium nisi sed luctus gravida. Donec in vehicula urna. Phasellus metus ex, faucibus vitae tortor vitae, malesuada varius nequve. Donec vel metus ornare, iaculis nunc sed, tempor lectus. Morbi sagittis erat et arcu dictum, in aliquam risus lobortis. Aliquam pulvinar, ipsum porttitor lacinia fringilla, quam orci scelerisque neque, nec tempor neque leo tempus sem. Praesent eget nulla nec nulla fermentum ornare. Quisque porta fringilla ipsum vel vehicula. Duis vel mattis ligula, at interdum diam.',
  },
  {
    id: 9,
    title: 'Як розпочати роботу над проектом?',
    description:
      'Phasellus maximus porta fermentum. Vivamus ut imperdiet enim, non convallis arcu. Mauris blandit vel leo ut lacinia. Praesent et cursus quam. Maecenas interdum semper orci nec mattis. Integer in blandit lqacus. Proin viverra erat condimentum dolor commodo, a iaculis risus tristique. Phasellus sed dapibus nunc, accumsan sollicitudin enim.',
  },
  {
    id: 10,
    title: 'Чи надаєте ви якісь гарантії чи поручительства на свою роботу?',
    description:
      'Suspendisse laoreet eros ac orci ornare, id eleifend mauris laoreet.',
  },
];